/** BLE GATT UUIDs matching firmware main.cpp lines 62-65 */
export const BLE_SERVICE_UUID = '4fafc201-1fb5-459e-8fcc-c5c9c331914b';
export const CHAR_ALERT_UUID = 'beb5483e-36e1-4688-b7f5-ea07361b26a8';
export const CHAR_SPECTRUM_UUID = 'beb5483e-36e1-4688-b7f5-ea07361b26a9';
export const CHAR_DEVICES_UUID = 'beb5483e-36e1-4688-b7f5-ea07361b26aa';

export type ConnectionState =
  | 'disconnected'
  | 'scanning'
  | 'connecting'
  | 'connected'
  | 'reconnecting'
  | 'error';

export interface BLEConnectionInfo {
  state: ConnectionState;
  device: BluetoothDevice | null;
  error: string | null;
  rssi: number | null;
  reconnectAttempts: number;
}
